import atradeStockBanner from "../../../media/software/atrade/stock_banner.png";

const atradeData = {
    name: "ATrade",
    category: "FinTech / Agentic AI",
    tagline: "Autonomous LangGraph-powered trading agent",
    duration: "Winter 2025",
    heroImage: atradeStockBanner,

    description: "[[ATrade::https://github.com/Madmaxme/ATrade]] is an autonomous day-trading agent hosted continuously on Railway. Built on LangGraph with Google's Gemini models, it reads market state, evaluates trading signals, and executes orders through the Alpaca MCP server. The system scrapes current S&P 500 constituents from Wikipedia and scans for RSI mean-reversion opportunities filtered by volume and ATR. I integrated the Tavily Search API for news cross-referencing before execution. A Reflexion memory system serializes optimization results to JSON, enabling the agent to analyze historical performance and adjust parameters over time.",

    highlight: "Currently in active development and undergoing paper trading validation.",

    techStack: [
        "Python",
        "LangGraph",
        "Google Gemini",
        "Alpaca MCP",
        "Tavily Search API",
        "Railway",
        "Docker",
        "Pandas",
        "Wikipedia API",
        "Mean Reversion Strategy",
        "yFinance",
        "AsyncIO"
    ],

    gallery: [
        /* Uncomment and populate when you have assets
        { type: 'video', src: atradeDemo, alt: 'ATrade agent scanning and executing live trades in terminal' },
        { type: 'image', src: atradeGraph, alt: 'LangGraph architecture visualization showing agent state machine' },
        { type: 'image', src: atradeTerminal, alt: 'Real-time decision logs showing AI reasoning for trade entry' },
        */
    ],
    links: {
        github: "https://github.com/Madmaxme/ATrade",
    },
};

export default atradeData;